export function base64ToFile(base64String: string, fileName: string): File {
    const byteString = atob(base64String);
    const byteNumbers = new Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        const codePoint = byteString.codePointAt(i) ?? 0;
        byteNumbers[i] = codePoint;
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], fileName);
}

export type CapKeysContainer = {
    capKeysIptFile?: File | string | boolean | null;
    capKeysOptFile?: File | string | boolean | null;
    capKeysUnattendedFile?: File | string | boolean | null;
};

function appendCapKeysFileToFormData(formData: FormData, fieldName: string, value: File | string | boolean | null | undefined): void {
    if (!value) {
        return;
    }
    if (value instanceof File) {
        formData.append(fieldName, value);
    } else if (value !== true) {
        formData.append(fieldName, base64ToFile(value as unknown as string, `${fieldName}.txt`));
    }
}

export function appendCapKeysToFormData(formData: FormData, data: CapKeysContainer): void {
    appendCapKeysFileToFormData(formData, "capKeysIptFile", data.capKeysIptFile);
    appendCapKeysFileToFormData(formData, "capKeysOptFile", data.capKeysOptFile);
    appendCapKeysFileToFormData(formData, "capKeysUnattendedFile", data.capKeysUnattendedFile);
}
